module.exports = __webpack_public_path__ + "static/img/more_heard1.cd716a1c.png";